import apiService from "./apiService";
import type { AxiosResponse } from "axios";
import type {
  LoginCredentials,
  LoginResponse,
  MeResponse,
} from "../types/auth.types";
import { API_ROUTES } from "../config/apiRoutes";

let currentUserRequest: Promise<AxiosResponse<MeResponse>> | null = null;

const getCurrentUser = () => {
  if (!currentUserRequest) {
    currentUserRequest = apiService
      .get<MeResponse>(API_ROUTES.AUTH.ME)
      .finally(() => {
        currentUserRequest = null;
      });
  }

  return currentUserRequest;
};

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
  data?: { expires_in: number };
}

export interface VerifyTokenResponse {
  success: boolean;
  message: string;
  data?: {
    user_id: number;
    email: string;
    name: string;
    token: string;
  };
}

export interface ResetPasswordResponse {
  success: boolean;
  message: string;
}

export interface ResetPasswordData {
  token: string;
  password: string;
  password_confirmation: string;
}

export const authService = {
  login: async (credentials: LoginCredentials) => {
    await apiService.get(API_ROUTES.AUTH.CSRF_COOKIE);
    return apiService.post<LoginResponse>(API_ROUTES.AUTH.LOGIN, credentials);
  },

  logout: () => apiService.post(API_ROUTES.AUTH.LOGOUT),

  // React StrictMode monta dos veces los efectos en desarrollo. Reutilizar la
  // solicitud activa evita consultar /me dos veces sin cachear la sesión.
  me: getCurrentUser,

  forgotPassword: (email: string) =>
    apiService.post<ForgotPasswordResponse>(API_ROUTES.PASSWORD.FORGOT, {
      email,
    }),

  verifyToken: (token: string) =>
    apiService.post<VerifyTokenResponse>(API_ROUTES.PASSWORD.VERIFY_TOKEN, {
      token,
    }),

  resetPassword: (data: ResetPasswordData) =>
    apiService.post<ResetPasswordResponse>(API_ROUTES.PASSWORD.RESET, data),
};
